// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1rhu4","form":"styles_form__2H4J4"};